var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLineThicknessNone = function SvgLineThicknessNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.954 16H3v-2h11.954zM21 16h-1.954l-2-2H21zm-8.046-4H3v-1.5h8.454zM21 12h-5.954l-1.5-1.5H21zM9.954 9H3V8h5.954zM21 9h-8.954l-1-1H21z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.954 20 4 5.046 5.046 4 20 18.954z"
  })));
};
export default SvgLineThicknessNone;